import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';
import { refreshReminders } from '../refreshReminders';

export function useReminders() {
  const navigate = useNavigate();

  const [reminders, setReminders] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // `showLoading` false = recarga silenciosa, sem piscar o loading numa lista já exibida.
  const loadReminders = useCallback(
    (showLoading) => {
      if (showLoading) {
        setLoading(true);
      }
      return quarkusApi
        .get('/reminders', { headers: { Authorization: sessionStorage.getItem('token') } })
        .then((returnFromApi) => setReminders(returnFromApi.data))
        .catch((returnFromApi) => {
          setError(returnFromApi.response?.data);
          console.error('ops! ocorreu um erro' + returnFromApi);
          if (returnFromApi.response?.status === 401) {
            navigate('/expired-session');
          }
        })
        .finally(() => {
          if (showLoading) {
            setLoading(false);
          }
        });
    },
    [navigate],
  );

  const fetchReminders = useCallback(() => loadReminders(true), [loadReminders]);

  useEffect(() => {
    // Gerar os lembretes pode demorar, então não seguramos a home esperando: listamos o que já
    // existe e, quando o refresh termina, relistamos em silêncio para incorporar o que ele criou.
    fetchReminders();
    refreshReminders().then(() => loadReminders(false));
  }, [fetchReminders, loadReminders]);

  return { reminders, isLoading, error, refetch: fetchReminders };
}
